import React, { useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card } from '../ui/Card';
import { DatePicker } from '../ui/DatePicker';
import { Badge } from '../ui/Badge';
import { ActivityProgressBadge } from './ActivityProgressBadge';
import { ActivityDetailModal } from './ActivityDetailModal';
import { operativeActivitiesStore, getProgress, OperativeActivity } from '../../services/operativeActivities';
import { actionsStore, sortActions } from '../../services/actionsStore';
import { ActionsTable } from './ActionsTable';
import { ClipboardList, Calendar, User, FileText, Briefcase, Filter } from 'lucide-react';
export function WorkloadCard() {
  const navigate = useNavigate();
  const [filterStart, setFilterStart] = useState('');
  const [filterEnd, setFilterEnd] = useState('');
  const [selectedActivity, setSelectedActivity] = useState<OperativeActivity | null>(null);
  const [isDetailOpen, setIsDetailOpen] = useState(false);
  const [refresh, setRefresh] = useState(0);
  const actions = useMemo(() => {
    let items = actionsStore.getByResponsible('Alessio');
    if (filterStart) {
      const start = new Date(filterStart);
      items = items.filter(a => new Date(a.deadline) >= start);
    }
    if (filterEnd) {
      const end = new Date(filterEnd);
      items = items.filter(a => new Date(a.deadline) <= end);
    }
    return sortActions(items);
  }, [filterStart, filterEnd, refresh]);
  const formatDate = (dateStr: string) => {
    try {
      const d = new Date(dateStr);
      return d.toLocaleDateString('it-IT', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      });
    } catch {
      return dateStr;
    }
  };
  const handleActivityClick = (activity: OperativeActivity) => {
    setSelectedActivity(activity);
    setIsDetailOpen(true);
  };
  const handleStepComplete = (activityId: string, stepIndex: number) => {
    operativeActivitiesStore.completeStep(activityId, stepIndex);
    // Refresh the selected activity reference
    const updated = operativeActivitiesStore.getById(activityId);
    if (updated) setSelectedActivity({
      ...updated
    });
    setRefresh(r => r + 1);
  };
  const handleEditActivity = (activity: OperativeActivity) => {
    setIsDetailOpen(false);
    navigate('/operations');
  };
  const handleActionUpdate = () => {
    setRefresh(r => r + 1);
  };
  return <>
      <Card title={<div className="flex items-center gap-2" data-id="element-946" data-mp="slq1aha3ioit">
            <ClipboardList className="h-5 w-5 text-seform-orange" data-id="element-947" data-mp="ntq5n1126hs1" />
            <span data-id="element-948" data-mp="nrdgo3wvv75h">Carico di lavoro (Azioni)</span>
          </div>} description="Azioni operative assegnate a te" actions={<div className="flex items-center gap-2" data-id="element-949" data-mp="dw1ytcq6hjti">
            <Filter className="h-4 w-4 text-slate-400" data-id="element-950" data-mp="dt62ttxw557p" />
            <div className="flex items-center gap-2" data-id="element-951" data-mp="8v4iz6sn51v6">
              <DatePicker value={filterStart} onChange={e => setFilterStart(e.target.value)} data-id="element-952" data-mp="4uklu382hy91" />
              <span className="text-xs text-slate-400" data-id="element-953" data-mp="2ggw9a5augxb3">—</span>
              <DatePicker value={filterEnd} onChange={e => setFilterEnd(e.target.value)} data-id="element-954" data-mp="2kjj6klqabafo" />
            </div>
          </div>} noPadding data-id="element-945" data-mp="skex4gcqner6">
        <div className="max-h-[420px] overflow-y-auto custom-scrollbar" data-id="element-955" data-mp="2uhgpqutaeh1f">
          <ActionsTable actions={actions} showClient onActionUpdate={handleActionUpdate} data-id="element-956" data-mp="2ufcpcmulk05w" />
        </div>
      </Card>

      <ActivityDetailModal isOpen={isDetailOpen} onClose={() => setIsDetailOpen(false)} activity={selectedActivity} onStepComplete={handleStepComplete} onEdit={handleEditActivity} data-id="element-957" data-mp="21ttc5zqfoqoa" />
    </>;
}